<template>
  <v-container fluid>
       <v-dialog
      v-model="dialog"
      width="70%"
      persistent
    >
      <v-card flat>
        <v-card-title class="d-flex justify-space-between align-center">
          <h3 class="titleText--text">Split Variables</h3>
          <v-btn
            color="primary"
            icon
            @click="closewindow()"
          >
            <v-icon color="titleText">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
         <v-row>
      <v-col>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="4">
        <v-card height="400px" color="rgb(243, 245, 248, .4)" flat>
          <v-card-title class="titleText white--text">
            <h4>Variables</h4>
          </v-card-title>
          <v-card-text>
            <div style="height: 320px; overflow-y: scroll;">
              <v-card
                  v-for="item in variable_list"
                  class="d-flex justify-start align-center my-2 mx-2 pl-3 custom-shadow cursor__pointer"
                  role="rowgroup"
                  :key="item.variable"
                  height="54"
                  elevation="0"
                  :ripple="false"
                >
                  <div><v-checkbox v-model="item.selected" color="blue" on-icon="mdi-checkbox-marked-circle"
                    off-icon="mdi-checkbox-blank-circle-outline"></v-checkbox></div>
                  <div class="titleText--text font-weight-bold">{{ item.variable }}</div>
                </v-card>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="4">
        <v-card height="400px" color="rgb(243, 245, 248, .4)" flat>
          <v-card-title class="titleText white--text">
            <h4>Regions</h4>
          </v-card-title>
          <v-card-text>
            <div style="height: 320px; overflow-y: auto;">
              <v-checkbox
              color="title"
              dense
              v-model="chkallregion"
              class="ml-5 my-3"
              hide-details
              on-icon="mdi-checkbox-marked-circle"
              off-icon="mdi-checkbox-blank-circle-outline"
              @change="clickOnSelectAllRegion"
            >
            <template v-slot:label>
              <h5 class="titleText--text">Select all</h5>
            </template>
          </v-checkbox>
              <v-card
                  v-for="item in region_list"
                  class="d-flex justify-start align-center my-2 mx-2 pl-3 custom-shadow cursor__pointer"
                  role="rowgroup"
                  :key="item.variable"
                  height="54"
                  elevation="0"
                  :ripple="false"
                >
                  <div><v-checkbox v-model="item.selected" color="blue" on-icon="mdi-checkbox-marked-circle"
                    off-icon="mdi-checkbox-blank-circle-outline"></v-checkbox></div>
                  <div class="titleText--text font-weight-bold">{{ item.region }}</div>
                </v-card>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="4">
        <v-card height="400px" color="rgb(243, 245, 248, .4)" flat>
          <v-card-title class="titleText white--text">
            <h4>Dates</h4>
          </v-card-title>
          <v-card-text>
            <div style="height: 320px; overflow-y: auto;">
              <v-checkbox
              color="title"
              dense
              class="ml-5 my-3"
              hide-details
              on-icon="mdi-checkbox-marked-circle"
              off-icon="mdi-checkbox-blank-circle-outline"
              v-model="chkalldate"
              @change="clickOnSelectAllDate"
            >
            <template v-slot:label>
              <h5 class="titleText--text">Select all</h5>
            </template>
          </v-checkbox>
              <v-card
                  v-for="item in date_list"
                  class="d-flex justify-start align-center my-2 mx-2 pl-3 custom-shadow cursor__pointer"
                  role="rowgroup"
                  :key="item.variable"
                  height="54"
                  elevation="0"
                  :ripple="false"
                >
                  <div><v-checkbox v-model="item.selected" color="blue" on-icon="mdi-checkbox-marked-circle"
                    off-icon="mdi-checkbox-blank-circle-outline"></v-checkbox></div>
                  <div class="titleText--text font-weight-bold">{{ item.date }}</div>
                </v-card>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    </v-card-text>
        <v-card-actions> 
          <v-spacer />
          <v-btn
            class="ml-2"
            color="blue"
            depressed
            dark
            height="36"
            width="120"
            @click="SaveInDB()"
          >
            <span class="text-capitalize font-weight-bold">Save</span>
          </v-btn>
        </v-card-actions>
      </v-card>
       </v-dialog>
  </v-container>
</template>
<script>
import apifactory from "../api";

export default {
  data: () => ({
    variable_list: [],
    variable_list_selected: [],
    region_list: [],
    region_list_selected: [],
    date_list: [],
    date_list_selected: [],
    chkalldate: false,
    chkalldatedisabled: false,
    chkallregion: false,
     dialog: false,
  }),
  methods: {
    CallOnload(){
        this.dialog=true;
        this.call_api_get_varlist_for_split();
    },
    closewindow(){
         this.dialog=false;
         this.$parent.RefreshSplitDataView();
    },
    SaveInDB() {
      try {
        this.variable_list_selected = this.getselectedvariable();
        this.region_list_selected = this.getselectedregions();
        this.date_list_selected = this.getselecteddate();

        //let countvariable=this.variable_list.length;
        let countregion=this.region_list.length;
        let countdate=this.date_list.length;

        let countvariableselect = this.variable_list_selected.length;
        let countregionselect=this.region_list_selected.length;
        let countdateselect=this.date_list_selected.length;

        //alert('chkalldate' + this.chkalldate);
        //alert('chkallregion' + this.chkallregion);

        if (countvariableselect == null || countvariableselect == 0) {
          alert("Please select the Variable");
          return;
        }
         if (countregionselect == null || countregionselect == 0) {
          alert("Please select the Region");
          return;
        }
        if (countdateselect == null || countdateselect == 0) {
          alert("Please select the Date");
          return;
        }

        if (this.chkalldate == true && this.chkallregion == true) {
          alert("Sorry Can't select all date and all region .");
          return;
        }
        for (let varitem in this.variable_list_selected) {
          let var_variable = this.variable_list_selected[varitem];
         
          let var_region=[];
          let var_date=[];
        
          if(countregionselect == countregion)
          {
                var_region.push("ALL");
          }
          else{
               var_region=this.region_list_selected;
          }

          if(countdateselect == countdate)
          {
                var_date.push("ALL");
          }
          else{
               var_date=this.date_list_selected;
          }
          this.call_api_save_var_split(var_variable,JSON.stringify(var_region),JSON.stringify(var_date));
        }
      } catch (error) {
        alert(error);
      }
    },
    call_api_save_var_split(vvariable, vregion, vdateparam) {
      apifactory
        .api_save_var_split(vvariable, vregion, vdateparam)
        .then((res) => {
          if (res.status != 200) {
            // return false;
            alert("Sorry");
          } else {
           this.closewindow()
          }
        })
        .catch(function (error) {
          alert("call_api_save_var_split" + error);
          // return false;
        });
    },
    call_api_get_varlist_for_split() {
      this.variable_list = [];

      this.region_list = [];

      this.date_list = [];

      apifactory
        .api_get_varlist_for_split()
        .then((res) => {
          if (res.status != 200) {
            // return false;
            alert("Sorry");
          } else {
            // this.variable_list = res.data.variable_list;
            //variablelist
            let tempvarlist = [];
            tempvarlist = res.data.variable_list;
            let indexvar = 1;
            for (let item in tempvarlist) {
              let obj = new Object();
              obj.id = indexvar;
              obj.variable = tempvarlist[item];
              obj.selected = false;
              indexvar = indexvar + 1;
              this.variable_list.push(obj);
            }
            //end
            let tempregionlist = [];
            tempregionlist = res.data.region_list;
            let index = 1;
            for (let item in tempregionlist) {
              let obj = new Object();
              obj.id = index;
              obj.region = tempregionlist[item];
              obj.selected = false;
              index = index + 1;
              this.region_list.push(obj);
            }
            // this.region_list = res.data.region_list;
            let tempdatelist = [];
            tempdatelist = res.data.date_list;
            let index1 = 1;
            for (let item in tempdatelist) {
              let obj = new Object();
              obj.id = index1;
              obj.date = tempdatelist[item];
              obj.selected = false;
              index1 = index1 + 1;
              this.date_list.push(obj);
            }
          }
        })
        .catch(function (error) {
          alert("call_api_get_varlist_for_split" + error);
          // return false;
        });
    },
    clickOnSelectAllDate() {
      if (this.chkalldate) {
        for (let item in this.date_list) {
          {
            this.date_list[item].selected = true;
          }
        }
      } else {
        for (let item in this.date_list) {
          {
            this.date_list[item].selected = false;
          }
        }
      }
    },
    clickOnSelectAllRegion() {
      if (this.chkallregion) {
        if (this.chkalldate) {
          alert("Sorry");
          this.chkalldatedisabled = true;
          return;
        }
        for (let item in this.region_list) {
          {
            this.region_list[item].selected = true;
          }
        }
      } else {
        for (let item in this.region_list) {
          {
            this.region_list[item].selected = false;
          }
        }
      }
    },
    getselectedregions() {
      let result = [];
      let newlist = this.region_list.filter((a) => a.selected == true);

      for (let item in newlist) {
        result.push(newlist[item].region);
      }
      return result;
    },
    getselecteddate() {
      let result = [];
      let newlist = this.date_list.filter((a) => a.selected == true);
      for (let item in newlist) {
        result.push(newlist[item].date);
      }
      return result;
    },
    getselectedvariable() {
      let result = [];
      let newlist = this.variable_list.filter((a) => a.selected == true);
      for (let item in newlist) {
        result.push(newlist[item].variable);
      }
      return result;
    },
  },
  computed: {
    checkalldateelectdiable() {
      return this.chkallregion;
    },
  },

  mounted() {
   
  },
};
</script>
<style scoped>
.scroll {
  overflow-y: scroll;
}
.vtoolbar {
  height: 40px !important;
}
.vtoolbartitle {
  font-size: 15px !important;
  margin-left: 3% !important;
  height: 40px !important;
  text-align: center !important;
}
.listtext {
  text-align: left !important;
}
.custom-shadow {
      box-shadow: 0px 8px 18px rgba(82, 111, 151, 0.06) !important;
    }
</style>
